import React, { Component } from "react";
import VerticalStepper from "../../../../../../Component/Stepper/VerticalStepper";
import ComposeLetter from "./ComposeLetter";
import ComposeEmail from "./ComposeEmail";
import PageHeader from "../../../../../../Component/Headers/pageHeader";

export default class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postData: {
        "templatename": (this.props.selecteddata && this.props.selecteddata.templatename) || null,
        "lettercategoryid": (this.props.selecteddata && this.props.selecteddata.lettercategoryid) || null,
        "bodypath": (this.props.selecteddata && this.props.selecteddata.bodypath) || null,
        "bodyvariableids": (this.props.selecteddata && this.props.selecteddata.bodyvariableids) || null,
        "bodycustomvariableids": (this.props.selecteddata && this.props.selecteddata.bodycustomvariableids) || null,
        "subject": (this.props.selecteddata && this.props.selecteddata.subject) || null,
        "subjectvariableids": (this.props.selecteddata && this.props.selecteddata.subjectvariableids) || null,
        "emailbodypath": (this.props.selecteddata && this.props.selecteddata.emailbodypath) || null,
        "emailvariableids": (this.props.selecteddata && this.props.selecteddata.emailvariableids) || null,
        "subscriptionlettertemplateid": (this.props.selecteddata && this.props.selecteddata.subscriptionlettertemplateid) || null,
        "deletefile": (this.props.selecteddata && this.props.selecteddata.subscriptionlettertemplateid) || null,
        btemplatebody: (this.props.selecteddata && this.props.selecteddata.templatebody) || null,
        bemailbody: (this.props.selecteddata && this.props.selecteddata.emailbody) || null,
        bbodypath: (this.props.selecteddata && this.props.selecteddata.bodypath) || null,
        bemailbodypath: (this.props.selecteddata && this.props.selecteddata.emailbodypath) || null,
      },
      templatebody: (this.props.selecteddata && this.props.selecteddata.templatebody) || null,
      emailbody: (this.props.selecteddata && this.props.selecteddata.emailbody) || null,
      activeStep: 0,
      AllStep: [],
      completed: false,
    };
    this.updatePostData = this.updatePostData.bind(this);
    this.setStep = this.setStep.bind(this);
    this.updateBody = this.updateBody.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.updateSteps = this.updateSteps.bind(this);
  }

  componentDidMount() {
    this.updateSteps();
    // if (this.props.history.location.pathname.includes("create")
    // || this.props.history.location.pathname.includes("edit")) {
    //   this.props.history.push(`${this.props.match.path}`);
    // }
  }

  updateSteps() {
    const AllStep = [
      {
        component: (
          <ComposeLetter
            {...this.props}
            {...this.state}
            onNextClick={this.onNextClick}
            updatePostData={this.updatePostData}
            setStep={this.setStep}
            updateBody={this.updateBody}
            setPreview={this.props.setPreview}
          />
        ),
        iserror: false,
        label: "Compose letter",
        step: 1,
      },
      {
        component: (
          <ComposeEmail
            {...this.props}
            {...this.state}
            onNextClick={this.onNextClick}
            updatePostData={this.updatePostData}
            setStep={this.setStep}
            updateBody={this.updateBody}
          />
        ),
        iserror: false,
        label: "Compose email",
        step: 2,
      },
    ];
    this.setState({ AllStep });
  }

  updateBody(key, value) {
    this.setState({ [key]: value }, () => {
      this.updateSteps();
    });
  }

  updatePostData(data) {
    this.setState({ postData: data }, () => this.updateSteps());
  }

  setStep(step, completed) {
    this.setState({ activeStep: step, completed });
  }

  onNextClick() {
    if (this.child) {
      this.child.handleNext();
    }
  }

  render() {
    return (
      <div style={{ display: "block", width: "100%" }}>
        <PageHeader header="Template creation" />
        <VerticalStepper
          AllStep={this.state.AllStep}
          onRef={(ref) => (this.child = ref)}
          activeStep={this.state.activeStep}
          setStep={this.setStep}
          completed={this.state.completed}
        />
      </div>
    );
  }
}
